<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title" *ngIf="header && header !== ''">{{ header }}</div>
    <div class="sopo-popup-text">
        <div class="left-container">
            <div class="subheader"> {{ subHeader }} </div>
            <div class="description"> {{ body }} </div>
        </div>
        <div class="right-container">
            <div class="icon-wrapper">
                <div class="icon-wrapper-shop">
                    <div class="icon-wrapper-shop-title">
                        <span class="title-number">{{ shopWrapper.titleNumber }}</span>
                        <span class="title-currency">{{ shopWrapper.titleType }}</span>
                    </div>
                    <img class="icon-wrapper-shop-bonus" src="assets/img/homepage/free-play/bonus-corner-flag.svg">
                    <div class="icon-wrapper-shop-text">
                        <span class="text-bonus">+ {{ shopWrapper.bonusNumber }} Bonus</span>
                        <span class="text-currency">{{ shopWrapper.bonusType }}</span>
                    </div>
                    <div class="icon-wrapper-shop-icon">
                        <div class="gold">
                            <img src="/assets/icon/chips/gold_chip.webp">
                        </div>
                        <div class="sweepstakes-and-plus">
                            <img class="sweepbuck" src="assets/img/sweep/money.webp">
                            <span class="plus">+</span>
                        </div>
        
                    </div>
                    <div class="icon-wrapper-shop-price">{{ shopWrapper.price }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-yellow-button ion-activatable clickable" (click)="close(false)">
            {{ cancelText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-green-button ion-activatable clickable" (click)="close(true)">
            {{ okText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
</div>
